import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import { fetchPois, type PoisFilters } from '../services/pois.service'

export { type PoiRow, type PoisFilters } from '../services/pois.service'

export function injectPoisQuery(filters: Signal<PoisFilters>) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['pois', filters()],
    queryFn: async ({ signal }) => {
      return fetchPois(cartoClient, filters(), signal)
    },
    enabled: filters().delivery_id > 0,
  }))
}
